import {ServiceRequestStep} from '../../../genericComponents/formTemplate/steps/ServiceRequestStep'
import './CompleteManufacturerItemCreationForm.scss'
import {StepSection} from './StepSection'
import {ItemCategoryChoice, ItemTypeChoice} from '../../NewItemServiceRequestChoiceCard'
import {Outlet} from 'react-router-dom'
import {IdentificationSection} from './component/IdentificationSection'
import {EvidenceDocumentsSection} from './component/EvidenceDocumentsSection'
import {AdditionalInformationSection} from './component/AdditionalInformationSection'
import {CommentsSection} from './component/CommentsSection'

export const CompleteManufacturerItemCreationForm = () => {
    return (
        <ServiceRequestStep>
            <StepSection title="Item Type">
                <ItemTypeChoice/>
            </StepSection>
            <Outlet/>
        </ServiceRequestStep>
    )
}

export const ManufacturerItemForm = () => {
    return (
        <>
            <StepSection title="Item Category" divider={true}>
                <ItemCategoryChoice/>
            </StepSection>
            <Outlet/>
        </>
    )
}

export const NewManufacturerHardware = () => {
    return <>
        <IdentificationSection/>
        <EvidenceDocumentsSection/>
        <AdditionalInformationSection/>
        <CommentsSection/>
    </>
}

